import React, { useCallback, useEffect, useState } from 'react';

import { CountryPickerBanner as CountryPickerBannerComponent, Locale } from '@savebetter/components';

import { localeCookieDomain } from '../../../config';
import { deleteCookie, getCookieByName, getUrlParams, setCookie } from '../utils';

const PreferredLocaleCookieName = 'preferred_locale';
const RedirectTargetCookieName = 'redirect_target';

const setPlatformCookie = (currentPlatform: Locale) => {
  const expiresInDays = 365;
  const expires = new Date(Date.now() + expiresInDays * 24 * 60 * 60 * 1000);
  document.cookie = setCookie(PreferredLocaleCookieName, currentPlatform, {
    expires,
    domain: localeCookieDomain
  });
};

const CountryPickerBanner = () => {
  const [shouldShowBanner, setShouldShowBanner] = useState(false);

  // currentPlatform should always be en-us for this application
  const currentPlatform = ((typeof window !== 'undefined' && window.location.pathname.split('/')[1].toLowerCase()) ||
    'en-us') as Locale;
  const preferredLocale = getCookieByName(PreferredLocaleCookieName);
  const redirectTarget = getCookieByName(RedirectTargetCookieName);

  const isPreferredLocale = !preferredLocale || preferredLocale !== currentPlatform;
  const isRedirectTarget = !!redirectTarget;

  const setBannerVisibility = useCallback(() => {
    if (isRedirectTarget || isPreferredLocale) {
      setShouldShowBanner(true);
    }
  }, [isPreferredLocale, isRedirectTarget]);

  useEffect(() => {
    const urlParams = (typeof window !== 'undefined' && getUrlParams(location.href)) || {};

    if (urlParams[PreferredLocaleCookieName] === currentPlatform) {
      setPlatformCookie(currentPlatform);
    } else {
      setBannerVisibility();
    }
  }, [currentPlatform, setBannerVisibility]);

  const onSelectHandler = (locale: Locale) => {
    setPlatformCookie(locale);
    setShouldShowBanner(false);
    deleteCookie(RedirectTargetCookieName);
  };

  const onCloseHandler = (locale: Locale) => {
    setPlatformCookie(locale);
    setShouldShowBanner(false);
    deleteCookie(RedirectTargetCookieName);
  };

  return (
    <div>
      <CountryPickerBannerComponent
        currentPlatform={currentPlatform}
        shouldShowBanner={shouldShowBanner}
        selectHandler={onSelectHandler}
        closeHandler={onCloseHandler}
      />
    </div>
  );
};

export default CountryPickerBanner;
